import { styled } from 'linaria/react';
import React, { FC, PropsWithChildren } from 'react';
const Hidden: FC<PropsWithChildren> = ({
  children
}) => <HiddenWrapper>{children}</HiddenWrapper>;
export default Hidden;
const HiddenWrapper = /*#__PURE__*/styled('div')({
  name: "HiddenWrapper",
  class: "h1dy18s6",
  propsAsIs: false
});

require("./Hidden.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Hidden.tsx");